import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.813 2.5A2.813 2.813 0 0 0 5 5.313v19.375A2.813 2.813 0 0 0 7.813 27.5h4.536a5.9 5.9 0 0 1-1.099-3.437 5.944 5.944 0 0 1 5.938-5.938h6.875q.478 0 .937.075v-5.7h-7.187A2.813 2.813 0 0 1 15 9.688V2.5zm9.062.55v6.638c0 .516.42.937.938.937h6.638zm.313 16.325a4.69 4.69 0 0 0-4.688 4.688 4.69 4.69 0 0 0 4.688 4.687h1.25a.937.937 0 1 0 0-1.875h-1.25a2.816 2.816 0 0 1-2.813-2.812 2.816 2.816 0 0 1 2.813-2.813h1.25a.937.937 0 1 0 0-1.875zm5.625 0a.937.937 0 1 0 0 1.875h1.25a2.816 2.816 0 0 1 2.812 2.813 2.816 2.816 0 0 1-2.812 2.812h-1.25a.937.937 0 1 0 0 1.875h1.25a4.69 4.69 0 0 0 4.687-4.687 4.69 4.69 0 0 0-4.687-4.688zm-5.625 3.75a.937.937 0 1 0 0 1.875h6.875a.937.937 0 1 0 0-1.875z" }, null, -1)
  ]))]))
}
export default { render: render }